// coke-popup.component.ts
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AboutUsPages } from '../models/aboutUs-pages.model';
import { AboutUsService } from '../services/about-us.service';

interface CokeProduct {
  id: number;
  name: string;
  price: number;
  image: string;
  description: string;
}

@Component({
    selector: 'app-coke-popup',
    templateUrl: './coke-popup.component.html',
    styleUrls: ['./coke-popup.component.scss'],
    standalone: false
})
export class CokePopupComponent {
  showPrivacyBar: boolean = true;
  showModal: boolean = false;
  aboutUsPages: any;
  constructor(private aboutUsService: AboutUsService,) { }

  ngOnInit(): void {
    this.aboutUsService.getAll$().subscribe(x => {
      this.aboutUsPages = x.find(x => x.pageID == 2);
    });
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (cookieConsent) {
      this.showPrivacyBar = false;
    }


  }

  openModal(): void {
    this.showModal = true;
    console.log('Modal opened:', this.showModal); // Debug
  }

  closeModal(): void {
    this.showModal = false;
  }

  acceptCookies(): void {
    localStorage.setItem('cookieConsent', 'accepted');
    this.showPrivacyBar = false;
    this.closeModal();
  }

  rejectCookies(): void {
    localStorage.setItem('cookieConsent', 'rejected');
    this.showPrivacyBar = false;
    this.closeModal();
  }

  // For clicking outside to close
  onModalBackdropClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.classList.contains('privacy-modal')) {
      this.closeModal();
    }
  }
}